import { createReducer, on } from '@ngrx/store';
import { loadAction } from './configuration.actions';
import { loadReducer } from './configuration.reducer';

export const ConfigurationReducer = createReducer(
    {},
    on(loadAction, loadReducer),
);
